module.exports = __webpack_public_path__ + "img/assistencia-funeraria.91d455f5.jpeg";